import { render, staticRenderFns } from "./adjustments.vue?vue&type=template&id=32f8ce0e&scoped=true&"
import script from "./adjustments.js?vue&type=script&lang=js&"
export * from "./adjustments.js?vue&type=script&lang=js&"
import style0 from "./adjustments.scss?vue&type=style&index=0&id=32f8ce0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8ce0e",
  null
  
)

export default component.exports